import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
// import Router from 'next/router'
import { Copyright, Header, Footer } from "../components/common";

const Layout = ({ children, user }) => {
  const [loader, setLoader] = React.useState(true);
  React.useEffect(() => {
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  }, []);

  return (
    <React.Fragment>
      {/*   
      {loader && <Preloader />} */}
      <Header key={Math.random()} />
      <Outlet key={Math.random()} />
      {/* <GoTop scrollStepInPx="100" delayInMs="10.50" /> */}
      <Footer key={Math.random()} />
      <Copyright key={Math.random()} />
    </React.Fragment>
  );
};

export default Layout;
